import { createContext, useEffect, useState, type ReactNode } from 'react';

interface NewRecordContextValue {
  newRecord: string | null;
  setNewRecord: (id: string | null) => void;
}

export const NewRecordContext = createContext<NewRecordContextValue>({
  newRecord: null,
  setNewRecord: () => void 0,
});

interface NewRecordsProviderProps {
  children: ReactNode;
}

export function NewRecordsProvider(props: NewRecordsProviderProps) {
  const [ newRecord, setNewRecord ] = useState<string | null>(null);

  useEffect(() => {
    if (!newRecord) {
      return void 0;
    }
    const id = setTimeout(() => setNewRecord(null), 10_000);
    return () => clearTimeout(id);
  }, [ newRecord ]);

  return (
    <NewRecordContext.Provider value={{ newRecord, setNewRecord }}>
      {props.children}
    </NewRecordContext.Provider>
  );
}
